<bfy-loading />
<header>
    @if (hasInformationalMessage) {
        <div
            class="id-information-message-container contentWrapper__item contentWrapper__item-informationalHeader"
        >
            <div
                [innerHtml]="
                    globalContent | bfyContentFilter: 'informationalMessage' | bfySafeMarkup: 'html'
                "
            ></div>
        </div>
    }
    <div class="site-header container" id="site-header">
        <div>
            <a
                class="header-logo"
                id="lnkHomeLogo"
                href="/"
                title="{{ pageContent | bfyContentFilter: 'titleBfyLogo' }}"
            >
                <img
                    src="https://www.trustage.com/-/media/project/trustage/logos/trustage-logo-sb.svg"
                    alt="TruStage"
                    aria-hidden="true"
                />
            </a>
        </div>
        <div class="header-phone col-6">
            <div class="text-right">
                <a href="tel:{{ globalContent | bfyContentFilter: 'headerPhoneNumber' }}">
                    <span [innerHtml]="globalContent | bfyContentFilter: 'headerPhoneNumber'"></span
                ></a>
            </div>
        </div>
    </div>
</header>
<div class="contentWrapper__item contentWrapper__item-main">
    <div class="container__main">
        <main class="bfy-registration-container">
            <router-outlet />
        </main>
    </div>
</div>
<footer>
    <div class="container">
        <div class="outerflex">
            <div class="innerflex">
                <div class="item-container">
                    <div
                        class="footer-item"
                        [innerHtml]="
                            globalContent
                                | bfyContentFilter: 'footerColumnOne'
                                | bfySafeMarkup: 'html'
                        "
                    ></div>
                </div>
                <div class="item-container">
                    <div
                        class="footer-item"
                        [innerHtml]="
                            globalContent
                                | bfyContentFilter: 'footerColumnTwo'
                                | bfySafeMarkup: 'html'
                        "
                    ></div>
                </div>
                <div class="item-container">
                    <div
                        class="footer-item"
                        [innerHtml]="
                            globalContent
                                | bfyContentFilter: 'footerColumnThree'
                                | bfySafeMarkup: 'html'
                        "
                    ></div>
                </div>
            </div>
        </div>
    </div>
</footer>
